const locale = require('./activityStream.i18n.json');

/*@ngInject*/
const ActivityStreamController = function ($scope, $rootScope, $stateParams, submissionConstant,
                                                          coreConstant, submissionMediator,
                                                          submissionStateMediator, formViewerConstant,
                                                          appTypeConfigurationModel) {

    $scope.i18n = locale;

    $scope.viewModel = {
        formIsLoaded: false,
        isOpen: false,
        filterType: 'all',
        filterTypeLabel: _.get($scope.i18n, 'filter.all'),
        isSearchOpen: false,
        searchInput: '',
        streamItemList: [],
        mustRefreshActivityItems: true
    };

    $scope.getSearchPlaceholder = function () {
        return _.get($scope.i18n, 'searchPlaceholder') + ' ' + _.get($scope.i18n, 'filter.all');
    };

    $scope.onFilterClick = function (type) {
        $scope.viewModel.filterType = type;
        $scope.viewModel.filterTypeLabel = _.get($scope.i18n, 'filter.' + type);
    };

    function refreshActivityStreamItems() {
        if ($scope.viewModel.isOpen) {
            $scope.viewModel.isLoading = true;

            submissionMediator.loadActivityStreamItems($stateParams.submissionId).then(function (streamItems) {
                $scope.viewModel.streamItemList = streamItems;
            }).finally(function () {
                $scope.viewModel.isLoading = false;
                $scope.viewModel.mustRefreshActivityItems = false;
            });
        }
    }

    function saveState() {
        let toOmit = [
            'formIsLoaded',
            'streamItemList'
        ];
        submissionStateMediator.saveActivityStreamState($stateParams.submissionId, _.omit($scope.viewModel, toOmit));
    }

    function restoreState() {
        let savedViewModel = submissionStateMediator.getActivityStreamState($stateParams.submissionId);

        if (savedViewModel) {
            $scope.viewModel = _.extend($scope.viewModel, savedViewModel);

            if ($scope.viewModel.isOpen) {
                $rootScope.$broadcast(submissionConstant.event.ACTIVITY_STREAM_DID_OPEN);
            }
        }
    }

    function openDrawer() {
        $scope.viewModel.isOpen = true;
        if ($scope.viewModel.mustRefreshActivityItems) {
            refreshActivityStreamItems();
        }
        saveState();

        $rootScope.$broadcast(submissionConstant.event.ACTIVITY_STREAM_DID_OPEN);
    }

    function closeDrawer() {
        $scope.viewModel.isOpen = false;
        saveState();

        $rootScope.$broadcast(submissionConstant.event.ACTIVITY_STREAM_DID_CLOSE);
    }

    $scope.getActivityStreamMessage = function (activityStreamNote) {
        let message = activityStreamNote.simpleMessage;

        if (appTypeConfigurationModel.isUnderwriterWorkstation()) {
            if (activityStreamNote.statusReason) {
                message += ': ' + activityStreamNote.statusReason;
            }

            if (activityStreamNote.statusDetail) {
                message += ': ' + activityStreamNote.statusDetail;
            }
        }

        return message;
    };

    $scope.onToggleActivityStream = function () {
        return !$scope.viewModel.isOpen ? openDrawer() : closeDrawer();
    };

    $scope.onToggleSearch = function () {
        $scope.viewModel.isSearchOpen = !$scope.viewModel.isSearchOpen;
        if ($scope.viewModel.isSearchOpen) {
            $scope.$broadcast(coreConstant.event.ADVANCE_FOCUS, '.searchInput');
        }
        saveState();
    };

    $scope.onClearSearchInput = function () {
        $scope.viewModel.searchInput = '';
        $scope.onSearchInputChange();
    };

    // When this is invoked via the ng-change, it has already bee automatically debounced via ng-model-options.
    $scope.onSearchInputChange = function () {
        refreshActivityStreamItems();
        saveState();
    };

    $scope.$on(formViewerConstant.event.FORM_STRUCTURE_CHANGED, function () {
        $scope.viewModel.formIsLoaded = true;
    });

    $scope.$on(submissionConstant.event.CLOSE_ACTIVITY_STREAM, function (event) {
        closeDrawer();
    });

    $scope.$on(submissionConstant.event.TOGGLE_ACTIVITY_STREAM, function (event) {
        $scope.onToggleActivityStream();
    });

    $scope.$on(submissionConstant.event.REFRESH_SUBMISSION, function (event, submission) {
        if (parseInt($stateParams.submissionId) === submission.id) {
            $scope.viewModel.mustRefreshActivityItems = true;
        }
    });

    restoreState();
    refreshActivityStreamItems();
};

angular.module('gw-um-submission')
    .controller('activityStreamController', ActivityStreamController);
